// extracted by mini-css-extract-plugin
export default {"root":"ITBBookingAppointment--root--39HzS","text":"ITBBookingAppointment--text--GGbnl"};